import _ from 'lodash';

// TODO: type this — Vuex getter context types
/* eslint-disable @typescript-eslint/no-explicit-any */
type Ctx = any;
/* eslint-enable @typescript-eslint/no-explicit-any */

const permissionsVerification = {
    namespaced: true,
    getters: {
        hasPermissionFor:
            (state: Ctx, getters: Ctx, rootState: Ctx, rootGetters: Ctx) =>
            (specifiedPermission: string, id = '') => {
                const gameMasterControlActive = rootGetters['gmPermissions/permissionSettings'][specifiedPermission];
                if (gameMasterControlActive) {
                    return gmPermissionActiveFor[specifiedPermission]({ getters, id });
                } else {
                    return assumedPermissionFor[specifiedPermission]({ getters, id });
                }
            },
        getGameMasterStatus: (state: Ctx, getters: Ctx, rootState: Ctx, rootGetters: Ctx) => {
            return rootGetters['players/isGameMaster'](getters.currentUserId);
        },
        currentUserId(state: Ctx, getters: Ctx, rootState: Ctx) {
            return rootState.profile.me.id;
        },
        isCampaignOwner(state: Ctx, getters: Ctx, rootState: Ctx) {
            return getters.currentUserId === rootState.campaigns.activeCampaign.owner;
        },
        isCampaignOwnerById: (state: Ctx, getters: Ctx, rootState: Ctx) => (userId: string) => {
            return rootState.campaigns.activeCampaign.owner === userId;
        },
        isItemOwner: (state: Ctx, getters: Ctx) => (itemUserId: string) => {
            return getters.currentUserId === itemUserId;
        },
        isActiveMapOwner(state: Ctx, getters: Ctx, rootState: Ctx) {
            if (!_.isEmpty(rootState.gamestate.activeMap)) {
                return getters.currentUserId === rootState.gamestate.activeMap._userid;
            } else {
                return false;
            }
        },
        gmOrOwner: (state: Ctx, getters: Ctx) => (itemUserId: string) => {
            return getters.getGameMasterStatus || getters.isItemOwner(itemUserId);
        },
    },
};

const gmPermissionActiveFor: Record<string, (ctx: { getters: Ctx; id: string }) => unknown> = {
    gridControl: ({ getters }) => getters.getGameMasterStatus,
    fogControl: ({ getters }) => getters.getGameMasterStatus,
    editAnyMap: ({ getters, id }) => getters.gmOrOwner(id),
    hiddenTokens: ({ getters, id }) => getters.gmOrOwner(id),
    moveAll: ({ getters }) => getters.getGameMasterStatus,
};

const assumedPermissionFor: Record<string, (ctx: { getters: Ctx; id: string }) => unknown> = {
    gridControl: ({ getters }) => getters.isActiveMapOwner,
    fogControl: ({ getters }) => getters.isActiveMapOwner,
    editAnyMap: ({ getters, id }) => getters.isItemOwner(id),
    hiddenTokens: ({ getters, id }) => getters.isItemOwner(id),
    moveAll: ({ getters, id }) => getters.isItemOwner(id),
};

export default permissionsVerification;
